export enum dayWeek {
  DAY = 'day',
  WEEK = 'week',
}